{
  "page_count": "/ {n, plural, one{# 페이지} other{# 페이지}}"
}
